import { Button, TextInput } from 'flowbite-react';
import { useEffect, useState } from 'react';
import Loader from '../Common/Loader';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link, useParams } from 'react-router-dom';
import SearchApi from '../../Api/SearchApi';
import { useAppSelector } from '../../Reducers/store';
import { SearchRequest } from '../../Models/SearchRequest';
import { SearchResult } from '../../Models/SearchResult';
import { formatNumbers } from '../../Utils';
import InfiniteScroll from 'react-infinite-scroll-component';
import ManufacturerApi from '../../Api/ManufacturerApi';
import { Manufacturer } from '../../Models/Manufacturer';
import { FileTypeEnums } from '../../Models/FileType';
import DOMPurify from 'dompurify';
import { Category } from '../../Models/Category';
import { SubCategory } from '../../Models/SubCategory';

export default function ManufacturerSearchPage() {
  const { id } = useParams();
  const { userModel } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [manufacturerData, setManufacturerData] =
    useState<Manufacturer | null>();
  const [searchData, setSearchData] = useState<SearchResult[]>([]);
  const [filteredData, setfilteredData] = useState<SearchResult[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState<string | null>(
    null
  );

  const [categoryData, setCategoryData] = useState<Category[]>([]);
  const [subCategoryData, setSubCategoryData] = useState<SubCategory[]>([]);
  const [formData, setFormData] = useState<SearchRequest>({
    searchText: '',
    searchPartsText: '',
    manufacturers: null,
    categories: null,
    subCategories: null,
    minPrice: null,
    maxPrice: null,
    limit: 30,
    skip: 0,
    reset: true,
    equipmentType: null,
  });

  const getManufacturer = () => {
    if (id) {
      setIsLoading(true);
      ManufacturerApi.getManufacturer(id)
        .then((res) => {
          setManufacturerData(res.data);
          getSearchResults();
          ManufacturerApi.getManufacturerCategories(id)
            .then((res) => {
              setCategoryData(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
          ManufacturerApi.getManufacturerSubCategories(id)
            .then((res) => {
              setSubCategoryData(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setManufacturerData(null);
    }
  };

  useEffect(() => {
    getManufacturer();
  }, [id]);

  // useEffect(() => {
  //   if (selectedCategory) {
  //     // Filter dataSource based on the selectedCategory
  //     const filtered = filteredData.filter(
  //       (item) => item.categoryName === selectedCategory
  //     );
  //     setFilteredData(filtered);
  //   } else {
  //     setFilteredData(dataSource); // Show all data if no category is selected
  //   }
  // }, [selectedCategory, dataSource]);

  const [hasMore, setHasMore] = useState(true);
  const getSearchResults = async () => {
    setIsLoading(true);
    SearchApi.manufacturerSearch(formData, id!)
      .then((res) => {
        const results = sortEquipment(res.data ?? []);
        // API returns the full result set (no server pagination); avoid concatenating duplicates.
        setSearchData(results);
        setfilteredData(results);
        setHasMore(false);
        setFormData((prevData) => ({
          ...prevData,
          reset: false,
        }));
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const sortEquipment = (data: SearchResult[]) => {
    return [...data].sort((a, b) => {
      const nameA = a.equipmentName ?? '';
      const nameB = b.equipmentName ?? '';

      const isNumA = /^\d/.test(nameA); // ✅ Check if name starts with a number
      const isNumB = /^\d/.test(nameB);

      // ✅ Alphabetic names should come first
      if (!isNumA && isNumB) return -1;
      if (isNumA && !isNumB) return 1;

      // ✅ If both are alphabetic or both are numeric, sort normally
      return nameA.localeCompare(nameB, undefined, { numeric: true });
    });
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      formData.skip = 0;
      formData.reset = true;
      setHasMore(true);
      getSearchResults();
      return;
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    let newList = [...searchData];
    newList = newList.filter(
      (i) =>
        i.equipmentName
          ?.toLowerCase()
          .includes((formData.searchText ?? '').toLowerCase()) ||
        i.categoryName
          ?.toLowerCase()
          .includes((formData.searchText ?? '').toLowerCase()) ||
        i.subCategoryName
          ?.toLowerCase()
          .includes((formData.searchText ?? '').toLowerCase()) ||
        i.description
          ?.toLowerCase()
          .includes((formData.searchText ?? '').toLowerCase())
    );
    // console.log(newList);
    setfilteredData(newList);
  }, [formData.searchText]);

  return (
    <div
      id='scrollableDiv'
      className='w-full pt-4 h-[calc(100vh-60px)] md:h-[calc(100vh-130px)] overflow-y-auto '
    >
      <div className='flex flex-col p-2'>
        <div className='mb-5 pb-5 border-b-2'>
          <h1 className='text-gray-900 font-bold text-4xl pr-10 mb-5'>
            {manufacturerData?.name}
          </h1>
          <div className=''>
            {manufacturerData?.files &&
              manufacturerData.files?.filter(
                (x) => x.fileTypeId === FileTypeEnums.Photo
              ).length > 0 && (
                <img
                  src={
                    manufacturerData.files.filter(
                      (x) => x.fileTypeId === FileTypeEnums.Photo
                    )[0].fileUrl!
                  }
                  className='h-24 object-contain float-left mx-5 my-2'
                />
              )}
            <div className='pr-0 lg:pr-10'>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    manufacturerData?.description ?? ''
                  ),
                }}
              />
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className=''>
            <div className='w-full p-2'>
              <form
                id='searchForm'
                onSubmit={onSubmit}
                className='w-full flex flex-col items-center justify-center space-y-4'
              >
                {/* ✅ Search Input Label & Field (Centered) */}
                <div className='w-full text-center'>
                  <label className='block text-xl font-bold mb-2'>
                    Search {manufacturerData?.name}:
                  </label>
                  <TextInput
                    id='searchText'
                    name='searchText'
                    type='text'
                    placeholder='Search by Number, Category, or Description..'
                    onChange={handleChange}
                    value={formData.searchText ?? ''}
                    className='w-full rounded-lg text-center'
                  />
                </div>

                {/* ✅ Category & Subcategory Dropdowns (Second Row) */}
                {categoryData.length > 0 && (
                  <div className='flex flex-col md:flex-row justify-center items-center gap-4 w-full sm:w-3/4'>
                    {/* Category Dropdown */}
                    <div className='flex flex-col w-full'>
                      <label className='font-semibold text-gray-700'>
                        Category:
                      </label>
                      <select
                        value={selectedCategory || ''}
                        onChange={(e) => {
                          setSelectedCategory(e.target.value);
                          //setSelectedSubcategory(null);
                        }}
                        className='border rounded-lg w-full border-gray-300 text-gray-700 text-sm'
                      >
                        <option value=''>Select a Category</option>
                        {categoryData.map((category) => (
                          <option key={category.name} value={category.number}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className='flex flex-col w-full'>
                      <label className='font-semibold text-gray-700'>
                        Sub Category:
                      </label>
                      <select
                        value={selectedSubcategory || ''}
                        onChange={(e) => setSelectedSubcategory(e.target.value)}
                        className='border rounded-lg w-full border-gray-300 text-gray-700 text-sm'
                      >
                        <option value=''>Select a Sub Category</option>
                        {subCategoryData.map((category) => (
                          <option key={category.name} value={category.number}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
                {/* <Button type='submit' form='searchForm' className='buttonMain'>
                  Search
                </Button> */}
              </form>
            </div>
            <div className='w-full'>
              {filteredData.length === 0 && (
                <div className='w-full text-center text-lg p-5'>
                  No Results. Try adjusting your filters or selecting another
                  Manufacturer.
                </div>
              )}
              <div className='w-full overflow-y-auto'>
                <InfiniteScroll
                  dataLength={filteredData.length}
                  next={getSearchResults}
                  hasMore={hasMore}
                  loader={''}
                  scrollableTarget='scrollableDiv'
                >
                  <div className='flex flex-wrap gap-10 justify-center'>
                    {filteredData.map((data) => (
                      <div
                        key={data.equipmentId}
                        className='w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6'
                      >
                        <Link to={`/products/equipment/${data.equipmentId}`}>
                          <img
                            className='h-56 sm:h-64 xl:h-64 2xl:h-64 object-contain m-auto'
                            alt={data.equipmentName! + 'Logo'}
                            src={
                              data.imageURL
                                ? data.imageURL
                                : data.manufacturerImageURL
                                ? data.manufacturerImageURL
                                : blankImage
                            }
                          />
                          <div>
                            <h5 className='text-xl font-bold tracking-tight text-gray-900 text-center'>
                              {data.equipmentName!}
                            </h5>
                            {data.description && (
                              <h5 className='text-md font-bold tracking-tight text-gray-900 text-center'>
                                {data.description}
                              </h5>
                            )}
                            <h5 className='text-sm tracking-tight text-gray-900 text-center'>
                              {data.manufacturerName!}
                            </h5>
                            {data.categoryName && (
                              <h5 className='text-sm font-normal tracking-tight text-gray-900 text-center'>
                                {data.categoryName}
                              </h5>
                            )}
                            {data.subCategoryName && (
                              <h5 className='text-sm font-normal tracking-tight text-gray-900 text-center'>
                                {data.subCategoryName}
                              </h5>
                            )}
                          </div>
                          {(data.price ?? 0) > 0 && (
                            <div className='text-xl font-bold tracking-tight text-gray-900 text-center'>
                              ${formatNumbers(data.listPrice ?? 0)}
                            </div>
                          )}
                        </Link>
                        {data && (data.price ?? 0) > 0 && !userModel && (
                          <div className='flex justify-center'>
                            <Link to={'/login'}>
                              <Button
                                type='button'
                                // onClick={() => handleAddItemClick(equipmentData)}
                                className='buttonMain'
                              >
                                Login to order
                              </Button>
                            </Link>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
